import {BaseModal} from './baseModal';

export const Modal = BaseModal;
